module.exports = __webpack_public_path__ + "static/media/AngerActive.302a03f4.svg";